export default __webpack_public_path__ + "static/media/image.a-g-x-one.433c8512.png";